import { useTranslation } from "react-i18next";
import { COMPANY_OWNERSHIP_SETTINGS, companyOwnershipStatement } from "@contracts/company-ownership";
import { usePublicSite } from "@/public-site-context";

export default function CompanyOwnershipStatement({ className = "" }: { className?: string }) {
  const { i18n } = useTranslation();
  const language = i18n.language.startsWith("ar") ? "ar" : "en";
  const domain = usePublicSite();
  return <p data-company-ownership className={className}>{companyOwnershipStatement({ ...COMPANY_OWNERSHIP_SETTINGS, website: domain }, language)}</p>;
}
